module.exports = __webpack_public_path__ + "5c2c62d1d15e2a1911dc3e26ca354b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-shocking.png
// module id = 2057
// module chunks = 4